import React from "react";
import { Paper, PaperProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GlassCard = styled(Paper)(({ theme }) => ({
  background:
    theme.palette.mode === "dark"
      ? "rgba(26, 26, 28, 0.7)"
      : "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.1)"
      : "rgba(255, 255, 255, 0.18)"
  }`,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 8px 32px 0 rgba(0, 0, 0, 0.37)"
      : "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  transition: "background-color 0.3s ease, box-shadow 0.3s ease",
}));

export const GlassButton = styled("button")(({ theme }) => ({
  background:
    theme.palette.mode === "dark"
      ? "rgba(10, 132, 255, 0.1)"
      : "rgba(0, 122, 255, 0.1)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(10, 132, 255, 0.3)"
      : "rgba(0, 122, 255, 0.3)"
  }`,
  color: theme.palette.mode === "dark" ? "#0A84FF" : "#007AFF",
  padding: "8px 16px",
  borderRadius: "8px",
  fontSize: "0.9375rem",
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    background:
      theme.palette.mode === "dark"
        ? "rgba(10, 132, 255, 0.2)"
        : "rgba(0, 122, 255, 0.2)",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(0, 122, 255, 0.2)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
}));

interface GlassContainerProps extends Omit<PaperProps, "variant"> {
  children: React.ReactNode;
  glassVariant?: "card" | "modal" | "section";
}

export const GlassContainer: React.FC<GlassContainerProps> = ({
  children,
  glassVariant = "card",
  ...props
}) => {
  const getElevation = () => {
    switch (glassVariant) {
      case "modal":
        return 8;
      case "section":
        return 2;
      default:
        return 4;
    }
  };

  return (
    <GlassCard elevation={getElevation()} {...props}>
      {children}
    </GlassCard>
  );
};

export default GlassContainer;
